import { FunnelModeKey } from '../../../utils/apollo/graphqlSchema';
import { ICustomTooltipPropsOverride } from '../CustomTooltip/CustomTooltip';
import { IParsedChartDataFunnel } from '../interfaces';
import {
  IFunnelConversionTooltipContext,
  IFunnelFrequencyTooltipContext,
  IFunnelTimeToConvertTooltipContext,
  TooltipContextType,
} from '../CustomTooltip/tooltipContextInterfaces';
import { IFunnelDataKeysPerLine } from './dataKeysUtils';
import { UnreachableCaseError } from 'ts-essentials';

export const MIN_LENGTH_FOR_TIME_TO_CONVERT_TO_SKIP_MIDDLE_STEPS = 3;
/**
 * if we have 3 steps or more, we will use the last step color for s1 -> s3, or s1 -> s4
 * if the chart only has 2 steps, we will use the first step color for s1 -> s2
 */
export const isLastStepInFreqOrTTCWhichSkipMiddleSteps = (
  measureSelection: boolean[],
) => {
  return (
    !measureSelection.includes(false) &&
    measureSelection.length >=
      MIN_LENGTH_FOR_TIME_TO_CONVERT_TO_SKIP_MIDDLE_STEPS
  );
};

export const getFunnelTooltipOverride = (
  chartData: IParsedChartDataFunnel,
  dataKeysPerLine: IFunnelDataKeysPerLine,
): ICustomTooltipPropsOverride => {
  let tooltipContext: ICustomTooltipPropsOverride['tooltipContext'];
  const mode = chartData.mode;
  switch (mode) {
    case FunnelModeKey.Conversion:
      tooltipContext = {
        type: TooltipContextType.FUNNEL_CONVERSION,
        dataKeysPerLine,
      } as IFunnelConversionTooltipContext;
      break;
    case FunnelModeKey.Frequency:
      tooltipContext = {
        type: TooltipContextType.FUNNEL_FREQUENCY,
        measureControls: chartData.measureControls,
        dataKeysPerLine,
      } as IFunnelFrequencyTooltipContext;
      break;
    case FunnelModeKey.TimeToConvert:
      tooltipContext = {
        type: TooltipContextType.FUNNEL_TIME_TO_CONVERT,
        measureControls: chartData.measureControls,
        dataKeysPerLine,
      } as IFunnelTimeToConvertTooltipContext;
      break;
    default:
      throw new UnreachableCaseError(mode);
  }

  return {
    tooltipContext,
  };
};
